import config from "../boot/config";
import http from "../boot/http.js";

const route = "Facility/";

export default class {

    static GetFacilityInfo(siteId) {
        let url = `${config.baseUrl + route}GetFacilityInfo`;
        return http({ url, method: "GET", params: { siteId: siteId } })
          .then(data => data)
          .catch(error => error);
     }
}



// WEBPACK FOOTER //
// ./src/services/facility.js